export function initInScope($scope) {
    if (matchMedia('(max-width: 767px)').matches) {
        let $tabs = $scope.find('.js-scrollable-tabs').each(function () {
            let $nav = $(this);
            let $activeTab = $nav.find('.active');
            let $navTab = $nav.find('li');

            center($navTab, $activeTab);

            $navTab.on('show.bs.tab', function () {
                center($navTab, $(this))
            });
        })
    }
}

function center($navTab, $tab) {
    if ($tab && $tab.length) {
        let $parent = $tab.parent();
        let childPos = $tab.offset().left,
            parentScroll = $parent.scrollLeft(),
            offset = childPos + parentScroll - window.outerWidth / 2 + $tab.width() / 2;

        if ($parent.width() < $tab.width()) {
            offset = childPos + parentScroll - (+$parent.css('padding-right').replace(/[^\d]/g, ''));
        }

        $navTab.closest('ul').animate({scrollLeft: offset}, 250);
    }
}